<template>
  <span class="comment">
    <span class="comment-btn" @click="gotoWpsHome">
      <icon type="iconic_comment"></icon>评价
    </span>

    <div class="comment-modal" v-show="show" @click.stop>
      <div class="comment-modal-box">
        <div class="comment-modal-title">
          用户评价
          <icon
            type="iconic_cancel_pop"
            class="comment-modal-close"
            @click="handleClose"
          ></icon>
        </div>

        <div class="comment-modal-status" v-if="status.submitSuccess === true">
          <icon type="icontoast_hint"></icon>
          <p>提交成功，感谢您的反馈</p>
        </div>
        <div
          class="comment-modal-status"
          v-else-if="status.submitError !== null"
        >
          <icon type="icontoast_error"></icon>
          <p>{{ status.submitError }}</p>
        </div>
        <template v-else>
          <div class="comment-modal-content">
            <div class="comment-modal-item">
              <div class="comment-modal-item-label required">
                这个技巧对你有帮助吗？
                <span class="comment-modal-item-error" v-if="formError.useful"
                  >请评价</span
                >
              </div>
              <div class="comment-modal-item-content">
                <span
                  class="comment-modal-item-help-btn"
                  v-for="item in usefulBtns"
                  :key="item.value"
                  :class="{ active: item.value === form.useful }"
                  @click="handleSelUseful(item.value)"
                >
                  <icon :type="item.icon"></icon>{{ item.name }}
                </span>
              </div>
            </div>
            <div class="comment-modal-item">
              <div class="comment-modal-item-label">
                哪些地方我们可以做得更好？（选填）
              </div>
              <div class="comment-modal-item-content">
                <textarea
                  class="comment-modal-item-textarea"
                  placeholder="请输入反馈..."
                  v-model="form.content"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="comment-modal-bottom">
            <button class="comment-modal-submit" @click="submit">提交</button>
            <p class="comment-modal-tips">
              欢迎加入WPS学堂用户交流QQ群：721687646
            </p>
          </div>
        </template>
      </div>
    </div>
  </span>
</template>

<script>
import { query2Search } from '@/common/utils/index';
const usefulBtns = [
  {
    name: '有帮助',
    icon: 'iconic_useful',
    value: 1,
  },
  {
    name: '无帮助',
    icon: 'iconic_useless',
    value: 0,
  },
];

export default {
  data() {
    return {
      show: false,
      usefulBtns,
      hash: '',

      status: {
        submitSuccess: null,
        submitError: null,
      },

      form: {
        useful: null,
        content: '',
      },

      formError: {
        useful: false,
      },
    };
  },

  props: {
    id: [String, Number],
    series: [String, Number],
    reportClick: Function,
    reportShow: Function,
  },

  watch: {
    show(val) {
      if (!val) {
        this.status = {
          submitSuccess: null,
          submitError: null,
        };
      } else {
        // 上报展示
        this.reportShow({
          show: 'initial',
          area: 'video_tool',
          type: this.id,
          series: this.series
        });
      }
    },
  },

  methods: {
    handleShow() {
      this.show = true;
    },

    /** 跳到社区首页 */
    gotoWpsHome() {
      window.open(`https://home.wps.cn${query2Search({
        chan: 'xt08',
        academy: this.id
      })}`, '_blank');
    },

    handleClose() {
      this.show = false;
      this.reportClick({
        click: 'close',
        area: 'video_tool'
      });
    },

    handleSelUseful(value) {
      this.reportClick({
        click: value ? 'help' : 'nohelp',
        area: 'video_tool'
      });

      this.form.useful = value;
    },

    async submit() {
      const { form, id } = this;

      this.reportClick({
        click: this.form.useful ? 'helpsub' : 'nohelpsub',
        area: 'video_tool',
        type: this.id,
        series: this.series
      });

      // 校验必选项
      if (form.useful === null) {
        this.formError.useful = true;
        return;
      }

      if (!this.hash) {
        this.hash = await this.$service.learning.getFbToken().catch(() => '');
      }

      this.$service.learning
        .submitComment({
          content: form.content,
          isHelp: form.useful,
          id,
          fromChannel: 2,
          token: this.hash,
        })
        .then((res) => {
          if (res.code === 200) {
            this.status.submitSuccess = true;
          } else if (res.code === 300) {
            this.status.submitError = '操作频繁，请稍后再试';
          } else {
            this.status.submitError = '服务器错误，请稍后再试';
          }
        })
        .catch((err) => {
          this.$toast('未知错误，请重试', 'iconic_smile');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.comment {
  &-btn {
    @include btn-style();
  }

  &-modal {
    @include popup-style();
    cursor: default;

    &-box {
      background: #fff;
      width: 600px;
      min-height: 428px;
      padding-bottom: 16px;
      border-radius: 4px;
    }

    &-title {
      margin: 0 16px;
      padding: 16px 0;
      font-size: 18px;
      font-weight: 900;
      line-height: 28px;
      @include flex-align-center();
      justify-content: space-between;
      border-bottom: 1px solid #e6e6e6;
    }
    &-close {
      @include close-btn-style();
      font-size: 16px;
      margin-right: 6px;
    }

    &-content {
      padding: 30px 40px 0;
    }
    &-item {
      margin-bottom: 40px;

      &:last-of-type {
        margin-bottom: 31px;
      }

      &-label {
        margin-bottom: 12px;

        &.required::before {
          content: '*';
          color: #eb5451;
        }
      }

      &-error {
        color: #eb5451;
      }

      &-help-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 24px;
        cursor: pointer;

        > .icon {
          font-size: 24px;
          color: #888;
        }

        &.active {
          color: #417ff9;
          > .icon {
            color: #417ff9;
          }
        }

        &:not(:last-of-type) {
          margin-right: 60px;
        }
      }

      &-textarea {
        width: 520px;
        height: 100px;
        border-radius: 2px;
        border: 1px solid #e8e8e8;
        outline: 0;
        resize: none;
        padding: 10px;
      }
    }

    &-bottom {
      text-align: center;
    }

    &-submit {
      display: inline-block;
      width: 149px;
      height: 34px;
      color: #ffffff;
      font-size: 14px;
      line-height: 34px;
      background: #417ff9;
      border-radius: 17px;
      border-width: 0px;
      outline: 0;
      cursor: pointer;
    }

    &-tips {
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      text-align: center;
      margin-top: 10px;
    }

    &-status {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 100px;
      font-size: 12px;

      > .icon {
        font-size: 56px;
        margin-bottom: 28px;
      }
    }
  }
}
</style>
